module.exports = "https://trybtryb-legacy.web.app/img/zoe.c91676eb.webp";